module.exports = __webpack_public_path__ + "img/withdraw_desktop.d1dd8384.svg";